import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { router } from './plugins.routes';
import { AuthGuard } from '../auth/auth.guard';
import { PluginListComponent } from './list/plugins.component';
import { CommonModule } from '@angular/common';
import { PluginsService } from './plugins.service';
import { TabsModule } from '../tabs/tabs.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PluginModalComponent } from './modal/plugin-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { RatingModule } from 'ngx-bootstrap/rating';
import { FormsModule } from '@angular/forms';
import { PreviewModule } from '../preview/preview.module';
import { KeysPipe } from './list/plugin-filter.pipe';
import { PremiumPipe } from './list/plugin-filter.pipe';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [PluginListComponent, PluginModalComponent, KeysPipe, PremiumPipe],
  exports: [PluginListComponent],
  entryComponents: [PluginModalComponent],
  imports: [
    HttpModule,
    CommonModule,
    router,
    BrowserModule,
    SharedModule,
    TabsModule,
    FormsModule,
    ModalModule,
    PreviewModule,
    TranslateModule,
    RatingModule.forRoot()
  ],
  providers: [AuthGuard, PluginsService]
})
export class PluginsModule {}



// WEBPACK FOOTER //
// ./src/app/modules/plugins/plugins.module.ts